<template>
  <a-rate v-model:value="data[propName]" :tooltips="widget.tips"
          :allow-half="widget.half" :count="widget.count" :disabled="info.status === 'show'" />
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {RateFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: RateFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
</script>

<style lang="scss" scoped>
.view {
  height: 100%;
  padding-left: 12px;
}
</style>
